import get from 'lodash.get';

const getPartnerSignupUrl = (rootState) => get(rootState, 'partner.properties.signupUrl', null);

export default getPartnerSignupUrl;
